﻿export interface IPolicy {
    id: string;
    submissionId: string;
    policyNumber: string;
    statusCId: number;
    writtenPremium: number;
    productLineCId: number;
    include:boolean;
}

export class Policy {
    id: string;
    submissionId: string;
    policyNumber: string;
    statusCId: number;
    writtenPremium: number;
    productLineCId: number;
    include:boolean;
}